export function filterData(data, q) {
  const s = (q || "").trim().toLowerCase();
  if (!s) return data;

  return data
    .map((g) => {
      const matchGroup = (g.name || "").toLowerCase().includes(s);
      const kids = (g.children || []).filter((c) =>
        (c.name || "").toLowerCase().includes(s)
      );
      if (matchGroup || kids.length) return { ...g, children: kids };
      return null;
    })
    .filter(Boolean);
}
